module.exports = __webpack_public_path__ + "img/product-mode-group-temporary.eccd4d55.png";